import React from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';
import Select from '../../../components/ui/Select';
import Input from '../../../components/ui/Input';

const FilterControls = ({ 
  filters, 
  onFilterChange, 
  onClearFilters, 
  onBulkAction,
  selectedCount 
}) => {
  const requirementTypes = [
    { value: 'all', label: 'All Types' },
    { value: 'functional', label: 'Functional' },
    { value: 'technical', label: 'Technical' },
    { value: 'integration', label: 'Integration' },
    { value: 'reporting', label: 'Reporting' },
    { value: 'security', label: 'Security' }
  ];

  const complexityLevels = [
    { value: 'all', label: 'All Complexity' },
    { value: 'Low', label: 'Low' },
    { value: 'Medium', label: 'Medium' },
    { value: 'High', label: 'High' }
  ];

  const lobOptions = [
    { value: 'all', label: 'All LoB' },
    { value: 'OTC', label: 'Order to Cash' },
    { value: 'P2P', label: 'Procure to Pay' },
    { value: 'RTR', label: 'Record to Report' },
    { value: 'Plan', label: 'Plan to Produce' },
    { value: 'EWM', label: 'Extended Warehouse' }
  ];

  const assigneeOptions = [
    { value: 'all', label: 'All Assignees' },
    { value: 'Sarah Chen', label: 'Sarah Chen' },
    { value: 'Michael Rodriguez', label: 'Michael Rodriguez' },
    { value: 'David Kim', label: 'David Kim' },
    { value: 'Emma Thompson', label: 'Emma Thompson' },
    { value: 'unassigned', label: 'Unassigned' }
  ];

  const bulkActions = [
    { value: 'move-analyzing', label: 'Move to Analyzing' },
    { value: 'move-fit', label: 'Move to Fit' },
    { value: 'move-gap', label: 'Move to Gap' },
    { value: 'assign-me', label: 'Assign to Me' },
    { value: 'export-selected', label: 'Export Selected' }
  ];

  return (
    <div className="bg-card border border-border rounded-lg p-4 mb-6">
      {/* Search and Quick Actions */}
      <div className="flex flex-col lg:flex-row lg:items-center lg:justify-between gap-4 mb-4">
        <div className="flex-1 max-w-md">
          <Input
            type="search"
            placeholder="Search requirements..."
            value={filters?.search}
            onChange={(e) => onFilterChange('search', e?.target?.value)}
            className="w-full"
          />
        </div>
        
        <div className="flex items-center space-x-2">
          {selectedCount > 0 && (
            <div className="flex items-center space-x-2">
              <span className="text-sm text-muted-foreground">
                {selectedCount} selected
              </span>
              <Select
                placeholder="Bulk actions"
                options={bulkActions}
                value=""
                onChange={(value) => onBulkAction(value)}
                className="w-40"
              />
            </div>
          )}
          
          <Button
            variant="outline"
            iconName="RotateCcw"
            onClick={onClearFilters}
          >
            Clear Filters
          </Button>
          
          <Button
            variant="outline"
            iconName="Download"
            onClick={() => onBulkAction('export-all')}
          >
            Export
          </Button>
        </div>
      </div>
      {/* Filter Controls */}
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4">
        <Select
          label="Requirement Type"
          options={requirementTypes}
          value={filters?.type}
          onChange={(value) => onFilterChange('type', value)}
        />
        
        <Select
          label="Complexity"
          options={complexityLevels}
          value={filters?.complexity}
          onChange={(value) => onFilterChange('complexity', value)}
        />
        
        <Select
          label="Line of Business"
          options={lobOptions}
          value={filters?.lob}
          onChange={(value) => onFilterChange('lob', value)}
        />
        
        <Select
          label="Assignee"
          options={assigneeOptions}
          value={filters?.assignee}
          onChange={(value) => onFilterChange('assignee', value)}
        />
      </div>
      {/* Active Filters Display */}
      {(filters?.search || filters?.type !== 'all' || filters?.complexity !== 'all' || 
        filters?.lob !== 'all' || filters?.assignee !== 'all') && (
        <div className="flex flex-wrap items-center gap-2 mt-4 pt-4 border-t border-border">
          <span className="text-sm text-muted-foreground">Active filters:</span>
          
          {filters?.search && (
            <span className="inline-flex items-center px-2 py-1 text-xs bg-primary/10 text-primary rounded-full">
              Search: "{filters?.search}"
              <button
                onClick={() => onFilterChange('search', '')}
                className="ml-1 hover:text-primary/80"
              >
                <Icon name="X" size={12} />
              </button>
            </span>
          )}
          
          {filters?.type !== 'all' && (
            <span className="inline-flex items-center px-2 py-1 text-xs bg-primary/10 text-primary rounded-full">
              Type: {requirementTypes?.find(t => t?.value === filters?.type)?.label}
              <button
                onClick={() => onFilterChange('type', 'all')}
                className="ml-1 hover:text-primary/80"
              >
                <Icon name="X" size={12} />
              </button>
            </span>
          )}
          
          {filters?.complexity !== 'all' && (
            <span className="inline-flex items-center px-2 py-1 text-xs bg-primary/10 text-primary rounded-full">
              Complexity: {filters?.complexity}
              <button
                onClick={() => onFilterChange('complexity', 'all')}
                className="ml-1 hover:text-primary/80"
              >
                <Icon name="X" size={12} />
              </button>
            </span>
          )}
          
          {filters?.lob !== 'all' && (
            <span className="inline-flex items-center px-2 py-1 text-xs bg-primary/10 text-primary rounded-full">
              LoB: {lobOptions?.find(l => l?.value === filters?.lob)?.label}
              <button
                onClick={() => onFilterChange('lob', 'all')}
                className="ml-1 hover:text-primary/80"
              >
                <Icon name="X" size={12} />
              </button>
            </span>
          )}
          
          {filters?.assignee !== 'all' && (
            <span className="inline-flex items-center px-2 py-1 text-xs bg-primary/10 text-primary rounded-full">
              Assignee: {assigneeOptions?.find(a => a?.value === filters?.assignee)?.label}
              <button
                onClick={() => onFilterChange('assignee', 'all')}
                className="ml-1 hover:text-primary/80"
              >
                <Icon name="X" size={12} />
              </button>
            </span>
          )}
        </div>
      )}
    </div>
  );
};

export default FilterControls;